export const InboundActionTypes = {
    // -------------------------------------------------------I N  B O U N D-------------------------------------------------------

    INBOUND_DATA_FIRST: '@@inbound/INBOUND_DATA_FIRST',
    INBOUND_DATA_LOADING: '@@inbound/INBOUND_DATA_LOADING',
    INBOUND_DATA_SUCCESS: '@@inbound/INBOUND_DATA_SUCCESS',
    INBOUND_DATA_ERROR: '@@inbound/INBOUND_DATA_ERROR',

    GET_EDIT_INBOUND_DATA_FIRST: '@@inbound/GET_EDIT_INBOUND_DATA_FIRST',
    GET_EDIT_INBOUND_DATA_LOADING: '@@inbound/GET_EDIT_INBOUND_DATA_LOADING',
    GET_EDIT_INBOUND_DATA_SUCCESS: '@@inbound/GET_EDIT_INBOUND_DATA_SUCCESS',
    GET_EDIT_INBOUND_DATA_ERROR: '@@inbound/GET_EDIT_INBOUND_DATA_ERROR',
    GET_EDIT_INBOUND_DATA_RESET: '@@inbound/GET_EDIT_INBOUND_DATA_RESET',

    CREATE_INBOUND_DATA_FIRST: '@@inbound/CREATE_INBOUND_DATA_FIRST',
    CREATE_INBOUND_DATA_LOADING: '@@inbound/CREATE_INBOUND_DATA_LOADING',
    CREATE_INBOUND_DATA_SUCCESS: '@@inbound/CREATE_INBOUND_DATA_SUCCESS',
    CREATE_INBOUND_DATA_ERROR: '@@inbound/CREATE_INBOUND_DATA_ERROR',

    UPLOAD_INBOUND_DATA_FIRST: '@@inbound/UPLOAD_INBOUND_DATA_FIRST',
    UPLOAD_INBOUND_DATA_LOADING: '@@inbound/UPLOAD_INBOUND_DATA_LOADING',
    UPLOAD_INBOUND_DATA_SUCCESS: '@@inbound/UPLOAD_INBOUND_DATA_SUCCESS',
    UPLOAD_INBOUND_DATA_ERROR: '@@inbound/UPLOAD_INBOUND_DATA_ERROR',

    UPDATE_INBOUND_DATA_FIRST: '@@inbound/UPDATE_INBOUND_DATA_FIRST',
    UPDATE_INBOUND_DATA_LOADING: '@@inbound/UPDATE_INBOUND_DATA_LOADING',
    UPDATE_INBOUND_DATA_SUCCESS: '@@inbound/UPDATE_INBOUND_DATA_SUCCESS',
    UPDATE_INBOUND_DATA_ERROR: '@@inbound/UPDATE_INBOUND_DATA_ERROR',

    DELETE_INBOUND_DATA_FIRST: '@@inbound/DELETE_INBOUND_DATA_FIRST',
    DELETE_INBOUND_DATA_LOADING: '@@inbound/DELETE_INBOUND_DATA_LOADING',
    DELETE_INBOUND_DATA_SUCCESS: '@@inbound/DELETE_INBOUND_DATA_SUCCESS',
    DELETE_INBOUND_DATA_ERROR: '@@inbound/DELETE_INBOUND_DATA_ERROR',

    // -------------------------------------------------------T A G-------------------------------------------------------
    TAG_DATA_FIRST: '@@inbound/TAG_DATA_FIRST',
    TAG_DATA_LOADING: '@@inbound/TAG_DATA_LOADING',
    TAG_DATA_SUCCESS: '@@inbound/TAG_DATA_SUCCESS',
    TAG_DATA_ERROR: '@@inbound/TAG_DATA_ERROR',
    RESET_TAG_DATA: '@@inbound/RESET_TAG_DATA',

    TAG_NO_FIRST: '@@inbound/TAG_NO_FIRST',
    TAG_NO_LOADING: '@@inbound/TAG_NO_LOADING',
    TAG_NO_SUCCESS: '@@inbound/TAG_NO_SUCCESS',
    TAG_NO_ERROR: '@@inbound/TAG_NO_ERROR',

    UPDATE_ALL_DATA_FIRST: '@@inbound/UPDATE_ALL_DATA_FIRST',
    UPDATE_ALL_DATA_LOADING: '@@inbound/UPDATE_ALL_DATA_LOADING',
    UPDATE_ALL_DATA_SUCCESS: '@@inbound/UPDATE_ALL_DATA_SUCCESS',
    UPDATE_ALL_DATA_ERROR: '@@inbound/UPDATE_ALL_DATA_ERROR',

    UPDATE_ALL_YARDS_FIRST: '@@inbound/UPDATE_ALL_YARDS_FIRST',
    UPDATE_ALL_YARDS_LOADING: '@@inbound/UPDATE_ALL_YARDS_LOADING',
    UPDATE_ALL_YARDS_SUCCESS: '@@inbound/UPDATE_ALL_YARDS_SUCCESS',
    UPDATE_ALL_YARDS_ERROR: '@@inbound/UPDATE_ALL_YARDS_ERROR',

    UPDATE_SELECTED_DATA_FIRST: '@@inbound/UPDATE_SELECTED_DATA_FIRST',
    UPDATE_SELECTED_DATA_LOADING: '@@inbound/UPDATE_SELECTED_DATA_LOADING',
    UPDATE_SELECTED_DATA_SUCCESS: '@@inbound/UPDATE_SELECTED_DATA_SUCCESS',
    UPDATE_SELECTED_DATA_ERROR: '@@inbound/UPDATE_SELECTED_DATA_ERROR',

    UPDATE_SELECTED_UNIT_DATA_FIRST: '@@inbound/UPDATE_SELECTED_UNIT_DATA_FIRST',
    UPDATE_SELECTED_UNIT_DATA_LOADING: '@@inbound/UPDATE_SELECTED_UNIT_DATA_LOADING',
    UPDATE_SELECTED_UNIT_DATA_SUCCESS: '@@inbound/UPDATE_SELECTED_UNIT_DATA_SUCCESS',
    UPDATE_SELECTED_UNIT_DATA_ERROR: '@@inbound/UPDATE_SELECTED_UNIT_DATA_ERROR',

    UPDATE_INVENTORY_TRANSACTIONS_DATA_FIRST: '@@inbound/UPDATE_INVENTORY_TRANSACTIONS_DATA_FIRST',
    UPDATE_INVENTORY_TRANSACTIONS_DATA_LOADING: '@@inbound/UPDATE_INVENTORY_TRANSACTIONS_DATA_LOADING',
    UPDATE_INVENTORY_TRANSACTIONS_DATA_SUCCESS: '@@inbound/UPDATE_INVENTORY_TRANSACTIONS_DATA_SUCCESS',
    UPDATE_INVENTORY_TRANSACTIONS_DATA_ERROR: '@@inbound/UPDATE_INVENTORY_TRANSACTIONS_DATA_ERROR',

    GET_DETAILS_BY_TAG_FIRST: '@@inbound/GET_DETAILS_BY_TAG_FIRST',
    GET_DETAILS_BY_TAG_LOADING: '@@inbound/GET_DETAILS_BY_TAG_LOADING',
    GET_DETAILS_BY_TAG_SUCCESS: '@@inbound/GET_DETAILS_BY_TAG_SUCCESS',
    GET_DETAILS_BY_TAG_ERROR: '@@inbound/GET_DETAILS_BY_TAG_ERROR',

    GET_BY_DOC_FIRST: '@@inbound/GET_BY_DOC_FIRST',
    GET_BY_DOC_LOADING: '@@inbound/GET_BY_DOC_LOADING',
    GET_BY_DOC_SUCCESS: '@@inbound/GET_BY_DOC_SUCCESS',
    GET_BY_DOC_ERROR: '@@inbound/GET_BY_DOC_ERROR',

    GET_PRINT_CONTENT_FIRST: '@@inbound/GET_PRINT_CONTENT_FIRST',
    GET_PRINT_CONTENT_LOADING: '@@inbound/GET_PRINT_CONTENT_LOADING',
    GET_PRINT_CONTENT_SUCCESS: '@@inbound/GET_PRINT_CONTENT_SUCCESS',
    GET_PRINT_CONTENT_ERROR: '@@inbound/GET_PRINT_CONTENT_ERROR',

    GET_EXCEL_CONTENT_FIRST: '@@inbound/GET_EXCEL_CONTENT_FIRST',
    GET_EXCEL_CONTENT_LOADING: '@@inbound/GET_EXCEL_CONTENT_LOADING',
    GET_EXCEL_CONTENT_SUCCESS: '@@inbound/GET_EXCEL_CONTENT_SUCCESS',
    GET_EXCEL_CONTENT_ERROR: '@@inbound/GET_EXCEL_CONTENT_ERROR',

    UPDATE_TAG_BY_STATUS_FIRST: '@@inbound/UPDATE_TAG_BY_STATUS_FIRST',
    UPDATE_TAG_BY_STATUS_LOADING: '@@inbound/UPDATE_TAG_BY_STATUS_LOADING',
    UPDATE_TAG_BY_STATUS_SUCCESS: '@@inbound/UPDATE_TAG_BY_STATUS_SUCCESS',
    UPDATE_TAG_BY_STATUS_ERROR: '@@inbound/UPDATE_TAG_BY_STATUS_ERROR',

    UPDATE_ALL_SELLING_PRICE_FIRST: '@@inbound/UPDATE_ALL_SELLING_PRICE_FIRST',
    UPDATE_ALL_SELLING_PRICE_LOADING: '@@inbound/UPDATE_ALL_SELLING_PRICE_LOADING',
    UPDATE_ALL_SELLING_PRICE_SUCCESS: '@@inbound/UPDATE_ALL_SELLING_PRICE_SUCCESS',
    UPDATE_ALL_SELLING_PRICE_ERROR: '@@inbound/UPDATE_ALL_SELLING_PRICE_ERROR',

    UPDATE_SELECTED_DESCRIPTION_FIRST: '@@inbound/UPDATE_SELECTED_DESCRIPTION_FIRST',
    UPDATE_SELECTED_DESCRIPTION_LOADING: '@@inbound/UPDATE_SELECTED_DESCRIPTION_LOADING',
    UPDATE_SELECTED_DESCRIPTION_SUCCESS: '@@inbound/UPDATE_SELECTED_DESCRIPTION_SUCCESS',
    UPDATE_SELECTED_DESCRIPTION_ERROR: '@@inbound/UPDATE_SELECTED_DESCRIPTION_ERROR',

    UPDATE_ALL_DESCRIPTION_FIRST: '@@inbound/UPDATE_ALL_DESCRIPTION_FIRST',
    UPDATE_ALL_DESCRIPTION_LOADING: '@@inbound/UPDATE_ALL_DESCRIPTION_LOADING',
    UPDATE_ALL_DESCRIPTION_SUCCESS: '@@inbound/UPDATE_ALL_DESCRIPTION_SUCCESS',
    UPDATE_ALL_DESCRIPTION_ERROR: '@@inbound/UPDATE_ALL_DESCRIPTION_ERROR',

    UPDATE_ALL_UNITS_FIRST: '@@inbound/UPDATE_ALL_UNITS_FIRST',
    UPDATE_ALL_UNITS_LOADING: '@@inbound/UPDATE_ALL_UNITS_LOADING',
    UPDATE_ALL_UNITS_SUCCESS: '@@inbound/UPDATE_ALL_UNITS_SUCCESS',
    UPDATE_ALL_UNITS_ERROR: '@@inbound/UPDATE_ALL_UNITS_ERROR',

    GET_INVOICE_DATA_FIRST: '@@inbound/GET_INVOICE_DATA_FIRST',
    GET_INVOICE_DATA_LOADING: '@@inbound/GET_INVOICE_DATA_LOADING',
    GET_INVOICE_DATA_SUCCESS: '@@inbound/GET_INVOICE_DATA_SUCCESS',
    GET_INVOICE_DATA_ERROR: '@@inbound/GET_INVOICE_DATA_ERROR',

    GET_RECEIVER_DATA_FIRST: '@@inbound/GET_RECEIVER_DATA_FIRST',
    GET_RECEIVER_DATA_LOADING: '@@inbound/GET_RECEIVER_DATA_LOADING',
    GET_RECEIVER_DATA_SUCCESS: '@@inbound/GET_RECEIVER_DATA_SUCCESS',
    GET_RECEIVER_DATA_ERROR: '@@inbound/GET_RECEIVER_DATA_ERROR',

    STATE_EMPTY_FIRST: '@@inbound/STATE_EMPTY_FIRST',
};
